import script from "./PaymentMethodDetailForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentMethodDetailForm.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentMethodDetailForm.vue?vue&type=style&index=0&id=33bf8285&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33bf8285"]])

export default __exports__